import { logger } from '@/lib';

export const logFPTICTAContentKey = ({
  contentKey,
}: {
  contentKey: string;
}): void => {
  logger.fpti('cta_content_key', {
    field_value: contentKey,
    state_name: 'billing_page_cta_content_key',
    transition_name: 'prepare_billing_page_cta_content_key',
  });
};
